import {
  useMutation, UseMutationOptions, UseMutationResult,
} from 'react-query';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import {
  appendQueryParamIfNotEmpty, downloadFile, formatDate,
} from '../../../constants/hookConstants';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { TypeOfMutationFunction } from '../../../interfaces/query/queryHook.type';

interface GetExportReferrerParamsInterface{
    from: Dayjs | null,
    to: Dayjs | null,
    original: boolean,
    adCode?: string,
    search?: string,
    customFieldId?: number | string | null,
    customFieldName?: string | null,
}

export const useGetExportReferrerTable = (
  params : GetExportReferrerParamsInterface,
) => {
  const { t } = useTranslation();

  const queryParams = new URLSearchParams();
  queryParams.append('page', '0');
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(params.from || null));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(params.to || null));
  appendQueryParamIfNotEmpty(queryParams, 'rows', 10000);
  appendQueryParamIfNotEmpty(queryParams, 'adCode', params.adCode ?? '');
  appendQueryParamIfNotEmpty(queryParams, 'search', params.search ?? '');
  if (params.original) {
    appendQueryParamIfNotEmpty(queryParams, 'original', params.original.toString());
  }
  if (params.customFieldId !== undefined && params.customFieldId !== null && params.customFieldId !== '') {
    appendQueryParamIfNotEmpty(queryParams, 'customFieldId', params.customFieldId);
  }
  if (params.customFieldName) {
    appendQueryParamIfNotEmpty(queryParams, 'customFieldName', params.customFieldName);
  }

  const mutationFunction: TypeOfMutationFunction = async (acceptHeader: string) => {
    const url = `form-submission/referrer-report?${queryParams}`;
    await downloadFile(url, acceptHeader, t);
  };

  const options: UseMutationOptions<void, unknown, string> = {
    onError: () => {
      closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
    },
  };

  const mutation: UseMutationResult<void, unknown, string> = useMutation(
    mutationFunction,
    options,
  );

  return mutation;
};
